<template>
  <div>
    <c-tab
      ref="nearmissTab"
      type="horizon"
      :tabItems.sync="tabItems"
      :inlineLabel="true"
      v-model="tab"
      :dense="true"
      @tabClick="tabClick"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :popupParam="popupParam"
          :count="count"
          :attachInfo1.sync="attachInfo1"
          :attachInfo2.sync="attachInfo2"
          @changeStatus="changeStatus"
          @closePopup="closePopup"
          @transInfo="transInfo"
        />
      </template>
    </c-tab>
  </div>
      <!-- class="full-height" -->
</template>

<script>
import { uid } from 'quasar';
export default {
  name: 'near-accident-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      editable: true,
      splitter: 5,
      tab: 'nearAccidentInfo',
      count: 0,
      addTabItems: [],
      tabItems: [],
      attachInfo1: {
        isSubmit: '',
        taskClassCd: 'NEAR_FIRST_PICTURE',
        taskKey: '',
      },
      attachInfo2: {
        isSubmit: '',
        taskClassCd: 'NEAR_SECOND_PICTURE',
        taskKey: '',
      },
    };
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.tabItems = [
      { name: 'nearAccidentInfo', icon: 'edit', label: '아차사고 정보', component: () => import(`${'./nearAccidentInfo.vue'}`) },
      ];
      this.addTabItems = [
        { name: 'accidentCausePrevention', icon: 'auto_fix_normal', label: '방지 및 감소대책', component: () => import(`${'./nearCausePrevention.vue'}`) },
      ];
      if (this.popupParam.iimAccidentId) {
        this.tabItems = this.tabItems.concat(this.addTabItems);
      }
      this.$set(this.attachInfo1, 'taskKey', this.popupParam.iimAccidentId)
      this.$set(this.attachInfo2, 'taskKey', this.popupParam.iimAccidentId)
    },
    changeStatus(data) {
      this.tabItems = this.tabItems.concat(this.addTabItems);
      this.$set(this.attachInfo1, 'taskKey', data)
      this.$set(this.attachInfo1, 'isSubmit', uid())
      
      this.$set(this.attachInfo2, 'taskKey', data)
      this.$set(this.attachInfo2, 'isSubmit', uid())
    },
    closePopup(data) {
      this.$emit('closePopup', data);  
    },
    transInfo(data) {
      this.popupParam.iimAccidentId = data.iimAccidentId;
    },
    tabClick() {
      this.count++;
    },
  }
};
</script>
